import { Component } from '@angular/core';
import { PermaBaseComponent } from './perma-base.component';
import { RBCheck } from '@ldw/roesberg';

@Component({
    selector: 'ldw-custtreesearch',
    templateUrl: './component.html',
    styleUrls: ['./component.css'],
    standalone: false
})
export class CustomTreeSearchComponent extends PermaBaseComponent {
  protected process() {
    if (RBCheck.isNullOrEmpty(this.node)) {
      // no node given, so go to root of documents
      this.routerService.navigateToCustomNavigation(this.webDokuId, '');
      return;
    }
    // search in document tree
    this.routerService.navigateToCustomTreeSearch(this.webDokuId, this.node);
  }
}
